import React from "react";
import MenuSection from "./MenuSection";
import MenuItemSeparator from "./MenuItemSeparator";
import MenuItem from "./MenuItem";

export default class MenuSubmenu extends React.Component {
  render() {
    const { item, currentUrl, layoutConfig } = this.props;

    // Function to handle click and close sidebar on mobile
    const handleItemClick = () => {
      const isMobile = window.innerWidth < 1025;
      if (isMobile) {
        const closeBtn = document.getElementById('kt_aside_close_btn');
        if (closeBtn) {
          closeBtn.click();
        }
      }
    };

    return (
      <ul className="kt-menu__subnav">
        {item.submenu.map((child, index) => (
          <React.Fragment key={index}>
            {child.section && (
              <MenuSection
                item={child}
                parentItem={item}
                currentUrl={currentUrl}
              />
            )}

            {child.separator && (
              <MenuItemSeparator
                item={child}
                parentItem={item}
                currentUrl={currentUrl}
              />
            )}

            {child.title && (
              <MenuItem
                item={child}
                parentItem={item}
                currentUrl={currentUrl}
                layoutConfig={layoutConfig}
                onClick={handleItemClick}
              />
            )}
          </React.Fragment>
        ))}
      </ul>
    );
  }
}
